"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageTypes = void 0;
var messageTypes = {
  REGULAR: 'regular',
  EPHEMERAL: 'ephemeral',
  ERROR: 'error',
  REPLY: 'reply',
  SYSTEM: 'system'
};
exports.messageTypes = messageTypes;